import { Typography, Box } from "@mui/material";

const DailySalesReportErrorMessage = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="70vh"
      textAlign="center"
      overflow="hidden" // Prevents scrolling
      px={2} // Padding for better responsiveness
    >
      <Typography variant="h6" fontWeight="bold">
        This report is temporarily unavailable due to system maintenance. We are
        working to resolve the issue and restore access as soon as possible.
        Thank you for your patience.
      </Typography>
    </Box>
  );
};

export default DailySalesReportErrorMessage;
